"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Label_styles_1 = __importDefault(require("./Label.styles"));
var Label = function (_a) {
    var text = _a.text, color = _a.color;
    return react_1.default.createElement(Label_styles_1.default, { color: color }, text);
};
exports.default = Label;
